import Keycloak from 'keycloak-js';

const ssoUrl = process.env.REACT_APP_SSO_URL;
const ssoRealm = process.env.REACT_APP_SSO_REALM;
const ssoClientId = process.env.REACT_APP_SSO_CLIENT_ID;

// const _kc = new Keycloak('/keycloak.json');
const _kc = new Keycloak({
  url: ssoUrl,
  realm: ssoRealm,
  clientId: ssoClientId,
});

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
  _kc.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
  })
    .then((authenticated) => {
      if (!authenticated) {
        console.log('user is not authenticated..!');
      }
      onAuthenticatedCallback();
    })
    .catch(console.error);
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback) =>
  _kc.updateToken(15)
    .then(successCallback)
    .catch((params)=>{
      console.log('updateToken error', params);
      doLogin(params);
    });

const getUsername = () => _kc.tokenParsed?.preferred_username;
const getUserprofile = () => _kc.loadUserProfile();

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getUserprofile,
  hasRole,
};

export default KeycloakService;
